"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tooltip/style/index.js
// module id = 119
// module chunks = 1